import MotifHaloOrbit from '../../Pages/EmptyState/components/MotifHaloOrbit';

type LoadingProps = {
  title?: string;
};

const Loading = ({ title }: LoadingProps) => (
  <div className="flex w-full min-h-screen">
    <div className="m-auto flex flex-col items-center gap-6">
      <MotifHaloOrbit />
      {title && (
        <span
          className={[
            'font-semibold tracking-[-0.02em] text-center whitespace-pre-line text-2xl',
            'bg-clip-text text-transparent bg-[length:200%_100%]',
            'animate-halo-orbit-shimmer',
            'motion-reduce:animate-none motion-reduce:bg-none motion-reduce:text-[#534ab7] mt-4',
          ].join(' ')}
          style={{
            backgroundImage: 'linear-gradient(90deg, #7c6cf6 0%, #7c6cf6 30%, #c4bcfb 50%, #7c6cf6 70%, #7c6cf6 100%)',
          }}>
          {title}
        </span>
      )}
    </div>
  </div>
);

export default Loading;
